import Constants from "../utils/consts";

var http = require("follow-redirects").https;
var fs = require("fs");
var qs = require("querystring");

export default async function setValutazione(
  uname,
  token,
  id_corso,
  id_esame,
  id_studente,
  valutazione,
  userId,
  nomeEsame,
  recuperato = 0
) {
  return new Promise(function(resolve, reject) {
    var options = {
      method: "POST",
      hostname: Constants.ipAddress,
      path: Constants.apisFolder + "setValutazione.php",
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
        Cookie: "uid=e02675a1a7516909792f6850dffcd5fe",
      },
      maxRedirects: 20,
    };

    var req = http.request(options, function(res) {
      var chunks = [];

      res.on("data", function(chunk) {
        chunks.push(chunk);
      });

      res.on("end", function(chunk) {
        var body = Buffer.concat(chunks);

        const resp = JSON.parse(body.toString());
        resolve(resp);
      });

      res.on("error", function(error) {
        console.error(error);
      });
    });

    var postData = qs.stringify({
      token: token,
      uname: uname,
      id_corso: id_corso,
      id_esame: id_esame,
      id_studente: id_studente,
      valutazione: valutazione,
      user_id: userId,
      nome_esame: nomeEsame,
      recuperato: recuperato,
    });

    req.write(postData);

    req.end();
  });
}
